import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FlowsRoutingModule } from './flows-routing.module';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';

import { CommonModule } from '@angular/common';
import { FlowListComponent } from './flow-list/flow-list.component';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { FlowPageContainer } from './flow-page-container/flow-page.container';
import { FlowFilterComponent } from './flow-filter/flow-filter.component';

@NgModule({
  imports: [CommonModule, FlorderModule, FlowsRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  declarations: [
    FlowPageContainer,
    FlowFilterComponent,
    FlowListComponent,
  ],
  providers: [],
})
export class FlowsModule {}
